var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all_layout"},[_c('el-container',[_c('el-aside',[_c('SiderBar')],1),_c('el-container',[(_vm.showExit)?_c('el-header',[_c('HeadBar')],1):_c('div',[_c('HeadBar')],1),_c('el-main',{style:(_vm.showExit ? 'height:calc(100vh - 60px)' : 'height:calc(100vh)')},[_c('AppMain')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }